import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const systemConfigurationRedirectRoute: InvariantJiraRoute = {
	name: 'system-configuration-general-redirect',
	path: '/secure/admin/ViewApplicationProperties.jspa',
	exact: true,
};
